import { IconCheck } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

/** D-14: shown when the admin confirms the suggested fix worked — no ticket is created. */
export function ResolvedSuccessStep() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-8 text-center">
      <IconCheck size={40} className="text-[var(--color-forest)]" />
      <h2 className="text-[20px] font-semibold leading-[1.2] text-[var(--text-content-title)]">
        {t('intake.resolved.heading')}
      </h2>
      <p className="text-[15px] leading-[1.5] text-[var(--text-content-sub-title)]">
        {t('intake.resolved.body')}
      </p>
    </div>
  );
}

export default ResolvedSuccessStep;
